import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=e0fd66bc&scoped=true&"
import script from "./UserPreferences.vue?vue&type=script&lang=js&"
export * from "./UserPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fd66bc",
  null
  
)

export default component.exports